import type { FaireProductEntity } from "../../entity_types/product";

export const p_gbbmfcxpv2: FaireProductEntity = {
  token: "p_gbbmfcxpv2",
  type: "product",
  name: "Velvet Pumpkin Candle - FALL / HOLIDAY",
  brandToken: "b_7ltlwh1w",
  brandName: "True Hue",
  imageUrl:
    "https://cdn.faire.com/fastly/880e8d6d9de8919c5983c8f228e46510c6fb832260547b87e67fa6bd3c9574be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e96df9fbb642b28c3132743c47ee527860ce5bd5380bf31d867f3a912bb344bc.jpeg",
    "https://cdn.faire.com/fastly/76d5bea79231b95d7747857364a0107b7eb064f0156aea1aae6a2fad02588d2c.png",
    "https://cdn.faire.com/fastly/c3d227c4c6675355ccb2fe8b58b409c926e61480433a174fe1bbbab1afd0bb85.jpeg",
  ],
  priceDollars: 14.5,
  description:
    '• Excellent Christmas gift!\n\nNotes: Toasted Pumpkin + Vanilla Bean\n\nAutumn settles in after dark. Toasted pumpkin and vanilla bean melt into roasted chestnut and spiced chai, while black cardamom, cinnamon, and clove smolder beneath the surface. Warm, velvety, and quietly decadent - like candlelight caught in the folds of something soft.\n\nThis 7.75 oz candle is comprised of a premium soy wax blend and fine fragrance oils (all are Prop 65 and I.F.R.A. approved). Each candle comes complete with a braided cotton wick which burns cleanly for 40–50 hours.\n\nMeasurements:\n\n• Box Size: 2.9" L X 2.9" W X 3.3" H\n\n• Candle Size: 2.9" D X 3.25" H',
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:05.183Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
